module.exports = __webpack_public_path__ + "static/media/cut-transparent.37c637a8.png";